export default __webpack_public_path__ + "static/media/solarlight.fc8ee727.png";